<template>

    <div class="list row">
        <div class="col-md-10">
            <div>
                <h5>
                    Rollen
                </h5>
            </div>

            <ul class="list-group">
                <li class="list-group-item"
                    :class="{ active: index == currentIndex }"
                    v-for="(role, index) in roles"
                    :key="index"
                    @click="setActiveRole(role, index)">
                    {{ role.name }}
                </li>
            </ul>

        </div>
    </div>

</template>

<script>
    import AuthService from "../services/auth.service"

    export default {
        name: "role-list",
        data() {
            return {
                roles: [],
                currentRole: null,
                currentIndex: -1
            }
        },
        methods: {
            retrieveRoles() {
                AuthService.getAllRoles()
                    .then(response => {
                        // console.log(JSON.stringify(response.data));
                        this.roles = response.data
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            refreshList() {
                this.retrieveRoles();
                this.currentRole = null;
                this.currentIndex = -1;
            },
            setActiveRole(role, index) {
                this.currentRole = role;
                this.currentIndex = index;
                AuthService.setRole(this.currentRole)
                .then(response => {
                    console.log(JSON.stringify(response.data));
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {
            this.retrieveRoles();
        }
    }
</script>

<style>
    .list {
        text-align: left;
        max-width: 750px;
        margin: auto;
    }
</style>